import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  id?: string;
  overlaysId: string;
  name: string;
  durationInFrames: number;
  fps: number;
  height: number;
  width: number;
  size: number;
  src?: string;
  save?: boolean;
}

const saveVideo = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/clipdeck/save', payload);
  return res.data;
};

export const useSaveVideo = () => {
  return useMutation(saveVideo, { onSuccess: (data) => data });
};
